import setCurrentPage from "src/Utils/setCurrentPage";

const DATA_EV_DEMO_USE_CASE_3_DEMO_VIDEO_1 = {
  videoSrc: "EV/Use_case_3_demo.mp4",
  title: "TOWER LEASE CONTRACTS: DEMO VIDEO - PART 1",
  onClose: () => setCurrentPage(410),
};

export default DATA_EV_DEMO_USE_CASE_3_DEMO_VIDEO_1;
